import { render, staticRenderFns } from "./acidList.vue?vue&type=template&id=ccfbc96a&scoped=true&"
import script from "./acidList.vue?vue&type=script&lang=js&"
export * from "./acidList.vue?vue&type=script&lang=js&"
import style0 from "./acidList.vue?vue&type=style&index=0&id=ccfbc96a&lang=scss&scoped=true&"
import style1 from "./acidList.vue?vue&type=style&index=1&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfbc96a",
  null
  
)

export default component.exports